module.exports = __webpack_public_path__ + "static/media/Group 25.1d97e293.svg";